import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Fullenrich from "@/services/fullenrich";
import { RequestEnrichment } from "@/dtos/Fullenrich.dto";

/**
 * Composable for requesting contact enrichment
 */
export function useRequestEnrichment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      enrichment: RequestEnrichment & {
        enrichEmail?: boolean;
        enrichPhoneNumber?: boolean;
        organizationId?: string;
      }
    ) => {
      const result = await Fullenrich.requestEnrichment(enrichment);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to request enrichment");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}
